import { render, staticRenderFns } from "./nameDialog.vue?vue&type=template&id=3944b88a&scoped=true&"
import script from "./nameDialog.vue?vue&type=script&lang=js&"
export * from "./nameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3944b88a",
  null
  
)

export default component.exports